import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	progressText: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.footer.progress-text',
		defaultMessage: 'Importing issues',
		description: 'Progress bar text',
	},
	progressCompleteText: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.footer.progress-complete-text',
		defaultMessage: 'You are all set!',
		description: 'Progress bar complete text',
	},
	downloadLogButton: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.footer.download-log-button',
		defaultMessage: 'Download log',
		description: 'Incomplete popover dlowload log button.',
	},
	contactSupport: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.footer.contact-support',
		defaultMessage: 'Contact support',
		description: 'Incomplete popover dlowload log button.',
	},
});
